var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M11.803 1.148a.672.672 0 1 0-.95-.951L6 5.049 1.148.197a.672.672 0 1 0-.951.95L5.049 6 .197 10.852a.672.672 0 1 0 .95.95L6 6.952l4.852 4.852a.672.672 0 1 0 .95-.95L6.952 6z"
  })));
};
export default SvgCloseIcon;